import { render, staticRenderFns } from "./loan.vue?vue&type=template&id=69515ce6&scoped=true&"
var script = {}
import style0 from "./loan.vue?vue&type=style&index=0&id=69515ce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69515ce6",
  null
  
)

export default component.exports